import { ReactNode } from 'react'

import styles from '../../ProgramDetail.module.scss'

import { Flex, Typography } from '@percent/lemonade'
import { ProgramStatusBadge } from './ProgramStatusBadge'

export function ProgramDetailRow({
  title,
  status,
  children
}: {
  title: string
  status?: 'on' | 'off'
  children?: ReactNode
}) {
  return (
    <Flex className={styles.detailRow} align="stretch">
      <Typography className={styles.detailRowTitle}>{title}</Typography>
      <Flex justify="end">
        {status && <ProgramStatusBadge status={status} />}
        {children}
      </Flex>
    </Flex>
  )
}
